import CampaignCreativePageContent from "containers/admin/clients/campaign/campaign-creative-page/components/campaign-creative-page-content/campaign-creative-page-content";

const CampaignCreativePage = () => {
  return <CampaignCreativePageContent />;
};

export default CampaignCreativePage;
